import React from 'react'
import '../../assets/home/sousBlog.css'
import { Link } from 'react-router-dom'

function SousBlog() {
  return (
    <div className='container-fluid' id='sousblog'>
        <div className="blog-header">
            <h4 className='blog-subtitle'>BLOG</h4>
            <h3 className='blog-title'>ACTUALITÉS</h3>
            <button><Link to={"/blog"} className='lien'> Tout voir <img src="./images/fleche_blanche.svg" alt="" /></Link></button>
        </div>
        <div className="blog-body">
            <div className="blog-item">
                <img src="./images/categories/gelato.png" alt="" />
                <h1 className='item-title'>Un zoom sur le POD HHC</h1>
                <p className='item-date'>26 MARS 2021</p>
                <p className='item-desc'>
                    L’arrivée du POD-HHC d’un CBD shop situé dans 
                    le 11ème et 13ème arrondissement est l’un des produits 
                    phare de l’année 2022... 
                </p>
            </div>
            <div className="blog-item">
                <img src="./images/categories/gelato.png" alt="" />
                <h1 className='item-title'>Un zoom sur le POD HHC</h1>
                <p className='item-date'>26 MARS 2021</p>
                <p className='item-desc'>
                    L’arrivée du POD-HHC d’un CBD shop situé dans 
                    le 11ème et 13ème arrondissement est l’un des produits 
                    phare de l’année 2022... 
                </p>
            </div>
            <div className="blog-item">
                <img src="./images/categories/gelato.png" alt="" />
                <h1 className='item-title'>Un zoom sur le POD HHC</h1>
                <p className='item-date'>26 MARS 2021</p>
                <p className='item-desc'>
                    L’arrivée du POD-HHC d’un CBD shop situé dans 
                    le 11ème et 13ème arrondissement est l’un des produits 
                    phare de l’année 2022... 
                </p>
            </div>
            <div className="blog-item">
                <img src="./images/categories/gelato.png" alt="" />
                <h1 className='item-title'>Un zoom sur le POD HHC</h1>
                <p className='item-date'>26 MARS 2021</p>
                <p className='item-desc'>
                    L’arrivée du POD-HHC d’un CBD shop situé dans 
                    le 11ème et 13ème arrondissement est l’un des produits 
                    phare de l’année 2022... 
                </p>
            </div>
        </div>
    </div>
  )
}

export default SousBlog